import * as React from 'react'
import styled from 'styled-components'
import rightIcon from '../../icons/reusable/right.svg'

import { RoundScaleButton } from '../buttons'
import { Input } from './input'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 220px;
  position: relative;
`

export default ({
  input,
  type,
  text,
  meta: { error },
  onSubmit,
  maxLength,
  autoFocus,
  autoComplete,
  placeholder
}) => {
  return (
    <Container>
      <Input
        width="640px"
        type={type}
        text={text}
        input={input}
        maxLength={maxLength}
        placeholder={placeholder}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
      />
      {!error && (
        <RoundScaleButton
          animate={true}
          onClick={onSubmit}
          icon={rightIcon}
          mood="secondary"
          text="Next"
          size="l"
        />
      )}
    </Container>
  )
}
